import { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import clsx from "clsx";
const Select = ({
  options,
  selected,
  setSelected,
  placeholder,
  label,
  className,
  leadingIcon,
  labelClass,
  selectedClass,
  selectedOptionClass,
  dropdownClass,
  optionsClass,
  trailingIcon,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Animation variants
  const dropdownVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.2,
        ease: "easeOut",
      },
    },
    exit: {
      opacity: 0,
      y: -10,
      transition: {
        duration: 0.15,
        ease: "easeIn",
      },
    },
  };

  return (
    <div className={clsx("relative w-full", className)} ref={dropdownRef}>
      {label && (
        <label
          className={clsx(
            "text-sm text-[#FFFFFF] mb-3.5 inline-block",
            labelClass
          )}
        >
          {label}
        </label>
      )}

      <button className={selectedClass} onClick={() => setIsOpen(!isOpen)}>
        {leadingIcon}
        <div className="mr-3"></div>
        <span className="flex-grow text-left">
          {selected?.label || placeholder || "Select"}
        </span>
        <div className="ml-3">
          <motion.div
            animate={{ rotate: isOpen ? 180 : 0 }}
            transition={{ duration: 0.2 }}
          >
            {trailingIcon}
          </motion.div>
        </div>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className={dropdownClass}
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={dropdownVariants}
          >
            {options?.map((option, i) => (
              <motion.div
                key={i}
                className={clsx(
                  optionsClass,
                  selected?.value === option.value && selectedOptionClass
                )}
                onClick={() => {
                  setSelected(option);
                  setIsOpen(false);
                }}
              >
                {leadingIcon}
                {option.label}
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Select;
